import { ITaskResultDetail } from "@multiweb/types/contracts";
import { RequestContext } from "../../../RequestContext";

/**
 * Umožňuje pracovat s daty dlouhotrvajících operací
 * @includeToDoc
 */
export interface ITaskClient {
    /**
     * Získá detailní informace o dokončeném úkolu.
     * @param resultId Kód záznamu
     * @param requestContext Viz {@link RequestContext}
     */
    getResultDetails(resultId: string, requestContext?: RequestContext): Promise<ITaskResultDetail>;
}
